/* eslint-disable @typescript-eslint/camelcase */
import { Grid, makeStyles } from '@material-ui/core';
import { Formik } from 'formik';
import i18n from 'i18n';
import React from 'react';
import GenericForm from 'skyone-lib/lib/GenericForm';
import { applyI18n } from 'utils/helpers';
import Button from 'components/Button';
import formStyles from '../../Form/styles';
import screenFields from './screenFields';
import validationSchema from './schema';

const useStyles = makeStyles(formStyles);

export interface Props {
  onCancel: () => void;
  onSubmit: (values) => void;
  modelName: string;
}

const FormDuplicate = ({ onCancel, onSubmit, modelName }: Props) => {
  const classes = useStyles();

  return (
    <Grid
      item
      container
      className={classes.formContainerSpace}
      data-testid={'autosky-formduplicate'}
    >
      <Formik
        initialValues={{
          name: `${modelName}-copy`,
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ setFieldValue, submitForm, errors, values }) => (
          <Grid container spacing={2}>
            <GenericForm
              fields={values}
              screenFields={applyI18n(screenFields, i18n.language)}
              setFieldValue={setFieldValue}
              errors={errors}
            />
            <Grid container justify="flex-end" className={classes.buttonsBase}>
              <Grid container className={classes.buttonsAlign}>
                <Button id="submit-button" onClick={submitForm} submitButton>
                  {i18n.t('DUPLICATE_KEY')}
                </Button>
                <Button
                  id="cancel-button"
                  variant="outlined"
                  onClick={onCancel}
                >
                  {i18n.t('CANCEL_KEY')}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Formik>
    </Grid>
  );
};

export default FormDuplicate;
